const productDeleteModalStyles = {
  deleteModalContent: {
    width: "220px",
    height: "auto",
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "white",
    padding: "30px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    border: "none",
    textAlign: "center",
  },
  deleteModalTitle: {
    fontFamily: "Lexend",
    fontSize: "18px",
    lineHeight: "100%",
    color: "#050505",
    fontWeight: 500,
  },
  deleteModalText: {
    fontFamily: "Lexend",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "100%",
    color: "#656565",
    margin: "20px 0px",
  },
  deleteModalBtns: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "30px",
  },
  deleteModalCancelBtn: {
    width: "100%",
    height: "40px",
    border: "1px solid #050505",
    borderRadius: "0px",
    boxShadow: "none",
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "100%",
    color: "#050505",
    textTransform: "none",
    "&:hover": {
      border: "1px solid #050505",
    },
  },
  deleteModalYesBtn: {
    width: "100%",
    height: "40px",
    borderRadius: "0px",
    boxShadow: "none",
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "100%",
    color: "#FFF",
    textTransform: "none",
  },
};

export default productDeleteModalStyles;

